import config from '@/config'
import bus from '@/EventBus'
import axios from 'axios'

axios.defaults.baseURL = config.service.apiURL

// set Authorization header on given requests
const setAuthorizationHeader = config => {
	const token = localStorage.getItem('token')
	config.headers = token && config.url !== 'login_check' ? { Authorization: 'Bearer ' + token } : {}
	return config
}

// logout if user is not authorized
const logoutOnUnauthorized = error => {
	if (error.response.status === 401)
		bus.$emit('logout', 'Skończył się czas sesji. Proszę się ponownie zalogować.')
	return Promise.reject(error)
}

axios.interceptors.request.use(setAuthorizationHeader)
axios.interceptors.response.use(null, logoutOnUnauthorized)

export default axios
